import styled from 'styled-components';

import type { ChildrenType } from '@xing-com/badge';
import { NotificationBadge } from '@xing-com/badge';
import { zIndexElevatedLayer4 } from '@xing-com/layout-tokens';
import { spaceL, spaceM, spaceXS } from '@xing-com/tokens';

export const SuperEllipseWrapper = styled.div`
  display: flex;
  flex: 0 0 auto;
  position: relative;
`;

const spaceForCount = (countString: ChildrenType | undefined): string => {
  const count = Number(countString);
  return count > 99 ? spaceL : spaceM;
};

export const NotificationBadgeWithCount = styled(NotificationBadge)`
  position: absolute;
  z-index: ${zIndexElevatedLayer4};
  top: calc(${spaceXS} * -1);
  right: ${({ children }) => `calc(${spaceForCount(children)} * -1)`};
`;
